import React from 'react'
import PropTypes from 'prop-types'
import { Container } from '@scentregroup/ui'
import { Spotlight, SpotlightCard } from '../'
import { trackClickEvent } from './analytics'

const SpotlightModule = ({ moduleProps, useAlternateDesign }) => (
  <Container centred type="large">
    <Spotlight
      heading={moduleProps.title}
      shortDescription={moduleProps.shortDescription}
      alternateDesign={useAlternateDesign}
      {...moduleProps}
    >
      {(moduleProps.entries || []).map(entry => (
        <SpotlightCard
          {...entry}
          color={moduleProps.color}
          key={entry.id}
          alternateDesign={useAlternateDesign}
          onClick={() =>
            trackClickEvent(
              entry.title,
              moduleProps.heading || moduleProps.title
            )
          }
        />
      ))}
    </Spotlight>
  </Container>
)

SpotlightModule.propTypes = {
  useAlternateDesign: PropTypes.bool,
  moduleProps: PropTypes.object,
}

export default SpotlightModule
